import React from "react";

import { Button } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";

import { FormCard } from "./FormControls/FormCard";
import styles from "./Toolbar.module.scss";

export interface ToolbarStepperProps {
  titlePrev: string;
  titleNext: string;
  disablePrev: boolean;
  disableNext: boolean;
  onClickPrev?: (event: React.MouseEvent<any, MouseEvent>) => void;
  onClickNext?: (event: React.MouseEvent<any, MouseEvent>) => void;
}

export const ToolbarStepper = ({
  titlePrev,
  titleNext,
  disablePrev,
  disableNext,
  onClickPrev,
  onClickNext,
}: ToolbarStepperProps) => {
  /// ------ EVENTS

  /// ------ RENDER

  return (
    <>
      <div className={styles.toolbar}>
        <FormCard>
          <Row>
            <Col md="6" className="text-left">
              <Button
                outline
                size="sm"
                onClick={onClickPrev}
                disabled={disablePrev}
              >
                {titlePrev}
              </Button>
            </Col>
            <Col md="6" className="text-right">
              <Button size="sm" onClick={onClickNext} disabled={disableNext}>
                {titleNext}
              </Button>
            </Col>
          </Row>
        </FormCard>
      </div>
    </>
  );
};
